import React, { Component } from "react";

import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { observable, makeObservable } from "mobx";
import { IoIosArrowRoundBack } from "react-icons/io";
import Loader from "../Components/Loader";

import { observer, inject } from "mobx-react";
@inject("store")
@observer
class Logout extends Component {
    @observable password = "";

    constructor() {
        super();
        this.state = {
            loading: true,
        };

        makeObservable(this);
    }

    componentDidMount() {
        this.refresh = setInterval(() => {
            this.props.history.push(`/login`);
        }, 6000);
    }
    componentWillUnmount() {
        clearInterval(this.refresh);
    }




    // Currently Selected Input Option

    render() {
        return (
            <>
                <Helmet>
                    <title>{`Login - AgentAI`}</title>
                </Helmet>
                <div className="container mx-auto lg:px-4 py-4 min-h-screen flex flex-col items-center justify-center">
                    <div
                        className={`md:min-w-0 bg-dark-4 rounded-xl w-4/5 lg:w-1/3 h-80`}
                    >
                        <div className="text-center mb-0 mt-6 md:mt-20">
                            <div className="mx-auto text-center">
                                <img
                                    src="/ailogo.svg"
                                    className="logo-app h-20 mx-auto"
                                    alt="Agent AI"
                                />
                            </div>
                        </div>
                        {this.state.loading && (
                            <div className="text-center">
                                <Loader active={this.state.loading} className="w-10 h-10" />
                                <p className="text-c-yellow">Logging out.... <br />
                                    <br />You have signed in on another device. You can only be logged into one device at a time</p>
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(Logout);
